import { get,post } from '../../utils/http'
const provinceId = JSON.parse(localStorage.getItem('provinceId')) || 0;
const year = JSON.parse(localStorage.getItem('year')) || 0;
export const getCategories = (type = 3, parentId = 0, param) => get(`/xbag/college/category/${type}/${parentId}/gets`, param, true)
export const getMajors = (param) => post(`/xbag/college/specialty/gets`, param, true)//搜索专业
export const getDetail = (id) => get(`/xbag/college/specialty/id/${id}`, {}, true)//获取专业详情
export const getStatisticsSpecial = () => get(`/xbag/college/specialty/statistics/20`, {});//一级+二级 专业树
export const getSpecial=(categoryId,classifyId)=>post(`/xbag/college/specialty/gets`,{limit:9999,_s_type:20,_s_category_id:categoryId,_s_classifiy_id:classifyId,_s_gk_province_id:provinceId,_s_gk_year:year},true)//获取三级专业
//getSpecial _s_types
// SPECIALIZED((byte) 10, "专科"),
// UNDERGRADUATE((byte) 20, "本科"),
// HIDDEN_SPECIALIZED((byte) 30, "隐藏专科"),
// HIDDEN_UNDERGRADUATE((byte) 40, "隐藏本科"),
// CATEGORY_SPECIALIZED((byte) 50, "专科分类"),
// CATEGORY_UNDERGRADUATE((byte) 60, "本科分类");
export const getRecommendMajor = () => get(`/sjsy/api/recommend/xk/specialty`, {}, false)//选科辅导推荐专业



// WEBPACK FOOTER //
// ./src/api/major/index.js